import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import GoogleMapReact from "google-map-react";
import { useSiteContext } from "../contexts/site";

function LocationCard() {

  const { locale } = useSiteContext();
  const data = useStaticQuery(graphql`
    query LocationCard {
      firestore {
        ch: settings(locale: "ch") {
          tel
          address
          addressHint
          map {
            url
            apiKey
            zoom
            lng
            lat
          }
        }
        en: settings(locale: "en") {
          tel
          address
          addressHint
          map {
            url
            apiKey
            zoom
            lng
            lat
          }
        }
      }
    }
  `)
  const translations = {
    ch: {
      title: '診所地址：',
    },
    en: {
      title: 'Clinic Address:',
    }
  }
  const renderMarkers = (map, maps) => {
    let marker = new maps.Marker({
    position: { lat: data.firestore[locale]["map"]["lat"], lng: data.firestore[locale]["map"]["lng"] },
    map,
    title: 'Hong Kong Spine Centre'
    });
    return marker;
   };

  return (
    <div className="rounded-lg bg-mango text-white p-5 lg:p-8 max-w-md shadow-md mx-auto my-8">
      <h2 className="text-lg lg:text-2xl flex items-center">
        <svg className="w-6 lg:w-8 inline" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
          <path fill="currentColor" d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
        </svg>
        <span className="ml-2 font-light">{translations[locale]['title']}</span>
      </h2>
      <a href={data.firestore[locale]["map"]["url"]} className="my-3 flex items-center">
        <svg className="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
        </svg>
        <p className="text-sm lg:text-base">
          { data.firestore[locale]["address"] } <br/>
          { data.firestore[locale]["addressHint"] }
        </p>
      </a>
      <a href={`tel:${data.firestore[locale]["tel"]}`} className="my-3 flex items-center">
        <svg className="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
        </svg>
        {data.firestore[locale]["tel"]}
      </a>
      <div className="h-64">
        <GoogleMapReact
          bootstrapURLKeys={{ key: data.firestore[locale]["map"]["apiKey"] }}
          defaultCenter={{
            lat: data.firestore[locale]["map"]["lat"],
            lng: data.firestore[locale]["map"]["lng"]
          }}
          defaultZoom={data.firestore[locale]["map"]["zoom"]}
          onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
        />
      </div>
    </div>
  )
}

export default LocationCard;